import { render } from "./JobBulkEditControls.vue?vue&type=template&id=4f22182d&scoped=true&ts=true"
import script from "./JobBulkEditControls.vue?vue&type=script&lang=ts"
export * from "./JobBulkEditControls.vue?vue&type=script&lang=ts"

import "./JobBulkEditControls.vue?vue&type=style&index=0&id=4f22182d&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f22182d"]])

export default __exports__